import { Component } from "react";
import { Checkbox } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import { defaultTheme, components } from "react-select";
import InputBox from "./InputBox";
import MySelect from "./MySelect";
import withWidth from "@material-ui/core/withWidth";
const { colors } = defaultTheme;

const selectStyles = (hideSearch) => ({
  control: hideSearch
    ? () => ({ display: "none" })
    : (provided) => ({ ...provided, minWidth: 240, margin: 8 }),
  menu: () => ({ boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)" }),
});

const menuStyles = (theme) => ({
  menuContainer: {
    backgroundColor: theme.ModalBGColor,
    borderRadius: 4,
    marginTop: 0,
    padding: 5,
    position: "absolute",
    zIndex: 1300,
  },
});
const Menu = withStyles(menuStyles)(
  withWidth()(({ isMenuLeftAligned, ...props }) => {
    const shadow = "hsla(218, 50%, 10%, 0.1)";
    const { classes } = props;
    return (
      <div
        className={classes.menuContainer}
        style={{
          boxShadow: `0 0 0 1px ${shadow}, 0 4px 11px ${shadow}`,
          ...(isMenuLeftAligned
            ? { left: 0 }
            : { right: props.width === "lg" ? -14 : 0 })
        }}
        {...props}
      />
    );
  })
);
const Dropdown = ({ children, isOpen, target, onClose, isMenuLeftAligned = false }) => (
  <div style={{ position: "relative" }}>
    {target}
    {isOpen ? <Menu isMenuLeftAligned={isMenuLeftAligned}>{children}</Menu> : null}
    {isOpen ? <Blanket onClick={onClose} /> : null}
  </div>
);

const DropdownIndicator = () => (
  <div style={{ color: colors.neutral20, height: 16, width: 32 }}>
    <Svg>
      <path
        d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </Svg>
  </div>
);

const Option = withStyles(styles)((props) => {
  return (
    <div>
      <components.Option {...props}>
        <Checkbox
          classes={{ root: props.classes.checkBox }}
          checked={props.isSelected}
          onChange={() => null}
          inputProps={{ "aria-label": "primary checkbox" }}
          color="primary"
        />
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
});

const MultiValue = (props) => (
  <components.MultiValue {...props}>
    <span>{props.data.label}</span>
  </components.MultiValue>
);

const Blanket = (props) => (
  <div
    style={{
      bottom: 0,
      left: 0,
      top: 4,
      right: 0,
      position: "fixed",
      zIndex: 1299,
    }}
    {...props}
  />
);

const Svg = (p) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    focusable="false"
    role="presentation"
    {...p}
  />
);
class CustomMultiSelect extends Component {
  state = { isOpen: false, value: undefined };
  toggleOpen = () => {
    this.setState((state) => ({ isOpen: !state.isOpen }));
  };
  onSelectChange = (value) => {
    this.toggleOpen();
    this.setState({ value });
  };
  render() {
    const { isOpen } = this.state;
    const { classes, label, optionSelected, inputClasses, isMenuLeftAligned, persistentLabelText } =
      this.props;
    const selectedOptionsLength = optionSelected?.length ?? 0;
    return (
      <Dropdown
        isOpen={isOpen}
        onClose={this.toggleOpen}
        isMenuLeftAligned={isMenuLeftAligned}
        target={
          <InputBox
            onClick={this.toggleOpen}
            classes={inputClasses}
            optionSelected={optionSelected}
            label={label}
            persistentLabelText={persistentLabelText}
          />
        }>
        <MySelect
          autoFocus
          backspaceRemovesValue={false}
          components={{
            DropdownIndicator,
            IndicatorSeparator: null,
            Option,
            MultiValue
          }}
          isClearable={false}
          menuIsOpen
          closeMenuOnSelect={false}
          controlShouldRenderValue={false}
          hideSelectedOptions={false}
          onChange={this.props.handleChange}
          options={this.props.Options}
          className={classes.stopsSelectFilter}
          classNamePrefix={"select"}
          placeholder="Search..."
          styles={selectStyles(this.props.hideSearch)}
          tabSelectsValue={false}
          value={optionSelected}
          isMulti
          allowClearAll={selectedOptionsLength > 0}
          allowSelectAll={selectedOptionsLength === 0}
        />
      </Dropdown>
    );
  }
}

export default withStyles(styles)(CustomMultiSelect);
